'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { composeHandlers } from '@s7/react-utils';
import { useFooterAnalytics } from '../../analytics.js';
import { FooterCallCenter } from '../../../../Footer/components/CallCenter/FooterCallCenter.js';
import { composeOptions } from '../utils/composeOptions.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CallCenterContainer = function(props) {
    var settings = props.settings, handlers = props.handlers, others = _object_without_properties_loose(props, [
        "settings",
        "handlers"
    ]);
    var _ref = handlers || {}, onActionItemClick = _ref.onActionItemClick, onInfoItemClick = _ref.onInfoItemClick, onPrimaryPhoneLinkClick = _ref.onPrimaryPhoneLinkClick;
    var sendEvent = useFooterAnalytics();
    var dispatchActionItemClickEvent = function(item) {
        return sendEvent("click_cta", {
            item_category: "call_center",
            item_name: item.variant,
            ux_ui: "actions"
        });
    };
    var dispatchInfoItemClickEvent = function(item) {
        return sendEvent("click_cta", {
            item_category: "call_center",
            item_name: String(item.id),
            ux_ui: "info"
        });
    };
    var dispatchPrimaryPhoneItemClickEvent = function(_) {
        return sendEvent("click_cta", {
            item_category: "call_center",
            item_name: "phone_number"
        });
    };
    return /*#__PURE__*/ jsx(FooterCallCenter, _extends({}, settings, others, {
        onActionItemClick: composeHandlers(onActionItemClick, dispatchActionItemClickEvent, composeOptions),
        onInfoItemClick: composeHandlers(onInfoItemClick, dispatchInfoItemClickEvent, composeOptions),
        onPrimaryPhoneLinkClick: composeHandlers(onPrimaryPhoneLinkClick, dispatchPrimaryPhoneItemClickEvent, composeOptions)
    }));
};

export { CallCenterContainer };
